/* eslint-disable monsterverse-rules/no-uuid-literals */
export const TextureAssets = {
  BlastSplashTie: "591359df-9fbb-40c3-a1e6-2cc37b63cf89",
  TieYellowBlue: "e1acc78c-c608-4b41-841b-c7250ca44709",
  MonsterBallTie: "ef6603ca-bd5e-46b4-9365-06cef74a138a",

  SnowNoiseGrayscale: "2a6ced2a-33dc-46a7-8ddf-b76bd076e16a",

  FoamPerlinNoise: "e83eaa68-78db-4d37-8f19-6e9a0281d45a",
  WaterfallNoise: "a6af7a56-c2e3-4706-9155-434b0f011a1a",
  SideNoise: "198385c2-55ea-4af4-8551-e2a833303113",
  TopCaustics: "04e554c3-dbd8-4322-9e6e-94aa602311b7",
  OceanNormal: "c6126345-5e70-45c3-ac56-28ae6d2ffcf2",
  ForcefieldNoise: "40b24beb-fc9e-4b20-8cc5-2b73fa6137b4",
};
